import { CUSTOMER_APIS } from "@/api_framework/api_config";
import { ICustomerMobileValidationResponse } from "@/api_framework/api_modals/Users";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import { setLoading } from "@/app_redux/reducers/loading_reducer";

import axios, { AxiosError, AxiosResponse } from "axios";
import AxiosCurlirize from "axios-curlirize";
import { useCallback, useState } from "react";
import { useAPIUtils } from "../../useAPIUtils";
import { useConfiguration } from "../../useConfiguration";
import { useCurlLogger } from "../../useCurlLogger";

AxiosCurlirize(axios, () => {});
export const useMobileNumberValidationAPI = () => {
  const [isValid, setIsValid] = useState<boolean>(true);
  const [existingUserId, setExistingUserId] = useState<string>(null);
  const configuration = useConfiguration();
  const dispatch = useAppDispatch();
  const { captureError } = useAPIUtils();
  const { sendCurl } = useCurlLogger();
  const toggleLoadingState = (toggleState: boolean) => {
    dispatch(setLoading({ key: "isMobileNumberValidationInProgress", status: toggleState }));
  };

  const execute = useCallback(
    async (mobileNumber: string) => {
      toggleLoadingState(true);
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        await axios
          .get(`${CUSTOMER_APIS?.MOBILE_VALIDATION?.baseURL}${mobileNumber}/` ?? "", {
            params: {},
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          })
          .then((res: AxiosResponse<ICustomerMobileValidationResponse>) => {
            toggleLoadingState(false);
            if (res.data.status === true) {
              setIsValid(true);
              setExistingUserId(res.data.data.user_id);
            } else if (res.data.status === false) {
              setIsValid(false);
              setExistingUserId(null);
            }
          })
          .catch((e: AxiosError) => {
            sendCurl(e.config["curlCommand"]);
            toggleLoadingState(false);
            if (e.response.status === 400) {
              setIsValid(false);
              setExistingUserId(null);
            }
          });
      } catch (e: any) {
        toggleLoadingState(false);
        setIsValid(false);

        setExistingUserId(null);
      }
    },
    [dispatch],
  );
  return { isValid, existingUserId, execute };
};
